import * as mui from '@mui/material'
import React from 'react'

import { Calculate, Currency, ProductFeedingRates, Query, Standards } from 'types/graphql/schema'
import {UseQueryBaseReturnType} from 'utils/graphql'

import {Chart} from './Chart'
import {Controls, NotesState} from './Controls'
import {Summary} from './Summary'
import { valuesType } from '../../../utils/values'


export function Dashboard(props: {
  calculate: (values: valuesType) => void
  calculationResult: Calculate
  constants: UseQueryBaseReturnType & {data: Query}
  currencies: Currency[]
  feedingRates: ProductFeedingRates
  initialCurrency: Currency
  pdfRef?: React.RefObject<HTMLDivElement>
  notesState: NotesState
  standards: Standards 
}) {
  return (
    <mui.Box
      sx={{
        ...(props.pdfRef
          ? {
            position: 'relative',
            mt: '30px',
          }
          : {}
        )
      }}
    >
      <mui.Stack
        gap={2}
        mb={3}
        sx={{
          ...(props.pdfRef
            ? {
              position: 'sticky',
              top: '137px',
              width: '350px',
            }
            : {}
          )
        }}
      >
        <Chart calculationResult={props.calculationResult}/>
        <Summary calculationResult={props.calculationResult}/>
        <Controls
          calculate={props.calculate}
          currencies={props.currencies}
          feedingRates={props.feedingRates}
          initialCurrency={props.initialCurrency}
          isPdf={!props.pdfRef}
          pdfRef={props.pdfRef}
          products={props.constants.data.products}
          notesState={props.notesState}
          standards={props.standards}
        />
      </mui.Stack>
    </mui.Box>
  )
}